// extracted by mini-css-extract-plugin
export default {"Item":"PhotoItem_Item__2mwAk"};